module.exports = __webpack_public_path__ + "static/media/pradeep.e7a80d5e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/members/pradeep.jpg
 ** module id = 780
 ** module chunks = 0
 **/